import type {
  PointsHistoryQuery,
  PointsHistoryResponse,
  PointsProjectsUsageResponse,
  PointsRechargeGiftRequest,
  PointsRechargeResponse,
  PointsSessionsUsageResponse,
  PointsSummaryResponse,
} from '@/types';

import { request } from './client';

export const POINTS_GIFT_TYPE_CODE = 2;

export const PointsApi = {
  getSummary(): Promise<PointsSummaryResponse> {
    return request<PointsSummaryResponse>('/points/summary');
  },
  getHistory({
    page = 1,
    pageSize = 20,
    category = 'all',
    startAt,
    endAt,
    projectKey,
    conversationKey,
  }: PointsHistoryQuery = {}): Promise<PointsHistoryResponse> {
    const params = new URLSearchParams({
      page: String(page),
      page_size: String(pageSize),
    });
    if (category !== 'all') {
      params.set('category', category);
    }
    if (startAt) {
      params.set('start_at', startAt);
    }
    if (endAt) {
      params.set('end_at', endAt);
    }
    if (projectKey) {
      params.set('project_key', projectKey);
    }
    if (conversationKey) {
      params.set('conversation_key', conversationKey);
    }
    return request<PointsHistoryResponse>(`/points/history?${params.toString()}`);
  },
  getProjectsUsage(): Promise<PointsProjectsUsageResponse> {
    return request<PointsProjectsUsageResponse>('/points/usage/projects');
  },
  getSessionsUsage(projectKey: string): Promise<PointsSessionsUsageResponse> {
    return request<PointsSessionsUsageResponse>(
      `/points/usage/sessions?project_key=${encodeURIComponent(projectKey)}`,
    );
  },
  rechargeGiftPoints(input: PointsRechargeGiftRequest): Promise<PointsRechargeResponse> {
    const body: {
      user_id?: number;
      user_ids?: number[];
      all_users?: boolean;
      points?: number;
      type_code?: number;
      remark?: string;
    } = {};
    if (input.allUsers) {
      body.all_users = true;
    } else if (input.userIds && input.userIds.length > 0) {
      body.user_ids = input.userIds;
    } else if (input.userId !== undefined) {
      body.user_id = input.userId;
    }
    body.points = input.points;
    body.type_code = POINTS_GIFT_TYPE_CODE;
    body.remark = input.remark;

    return request<PointsRechargeResponse>('/points/recharge', {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },
};
